import { BOARD_CONFIG, IS_MIX_CATALOG } from "@/config/browserBoard";
import { mixLineupSlugs } from "@/config/mixLineup";
import type { HistoryThreadRef } from "@/features/history/historyIdentity";
import { useMixCandidateSlugs } from "@/features/settings/hooks/useMixCandidateSlugs";
import { useFromMixCatalog } from "@/shared/lib/mixReturn";

/** 閲覧・書込履歴のスレ概要をどの板から引くか。 */
export type HistorySummaryScope = Readonly<{
  /** summaryを引く板slug群。単板文脈では現在板のみ。 */
  slugs: readonly string[];
  /** 真なら各スレへ取得元板slug(`b`)を付け、リンクを板ページ遷移にする。 */
  tagBoard: boolean;
}>;

export function selectHistoryItemsForScope<T extends HistoryThreadRef>(
  items: readonly T[],
  scope: HistorySummaryScope,
): T[] {
  return items.filter((item) => scope.slugs.includes(item.boardSlug));
}

/**
 * /mixマウント、または `?mix` 付き板スレページでは全板の履歴を合算する。
 * 板マウント側は総合カタログ対象の登録状況を知らないため、ラインナップ+現在板を
 * 候補にして未登録板の取得失敗は呼び出し側で縮退させる。
 */
export function useHistorySummaryScope(): HistorySummaryScope {
  const fromMixCatalog = useFromMixCatalog();
  const mixSlugs = useMixCandidateSlugs();
  const nativeMixSlugs = useMixCandidateSlugs(mixLineupSlugs());
  if (IS_MIX_CATALOG) {
    return { slugs: mixSlugs, tagBoard: true };
  }
  if (fromMixCatalog) {
    const slugs = [
      BOARD_CONFIG.boardKey,
      ...nativeMixSlugs.filter((slug) => slug !== BOARD_CONFIG.boardKey),
    ];
    return { slugs, tagBoard: true };
  }
  return { slugs: [BOARD_CONFIG.boardKey], tagBoard: false };
}
